import { Box, Heading, Button, Text, Layer, TextInput } from "grommet";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { useStore } from "../../../../../Hooks/useStore";
import './ConfirmationDialog.css';

type ConfirmationDialogProps = {
  show: boolean;
  onCancel: () => void;
  onDone: () => void;
  title: string;
  typingValidationText: string;
  confimButtonText: string;
};

function ConfirmationDialog({
  show,
  onCancel,
  onDone,
  title,
  typingValidationText,
  confimButtonText,
}: ConfirmationDialogProps) {
  const { rootStore } = useStore();
  // const [confirmationText, setconfirmationText] = useState("");

  useEffect(() => {
    return () => {
      rootStore.chatStore.setconfirmationText("");
    };
  }, [show]);

  return (
    <>
      {show && (
        <Layer
          id="hello world"
          position="center"
          onClickOutside={onCancel}
          onEsc={onCancel}
          style={{borderRadius: "12px" }}
          className="dialog-box"
        >
          <Box className="dialog-container">
            <Text className="heading">
              Confirm
            </Text>
            <Text className="dialog-title m16">{title}</Text>
            <Text className="dialog-title mb16">
              Please type <Text className="dialog-title" style={{fontWeight: '700',textTransform: 'uppercase'}}>{typingValidationText}</Text> in the field below to
              confirm.
            </Text>
              <TextInput
              placeholder="Enter here"
              className="dialog-confirm-input"
                value={rootStore.chatStore.getConfirmationText}
                onChange={(event) => rootStore.chatStore.setconfirmationText(event.target.value)}
              />
            <Box
              as="footer"
              gap="small"
              direction="row"
              align="center"
              justify="center"
            >
              <Button className="cancel-btn" label="Cancel" onClick={onCancel} />
              <Button
              className="confirm-btn"
                label={
                  <Text color="white">
                    <strong>{confimButtonText}</strong>
                  </Text>
                }
                disabled={rootStore.chatStore.getConfirmationText.toLowerCase() !== typingValidationText.toLowerCase()}
                onClick={onDone}
              />
            </Box>
          </Box>
        </Layer>
      )}
    </>
  );
}

export default observer(ConfirmationDialog);
